import styled from 'styled-components';

export const popUpBottom=styled.div`
    height:80px;
    border-top:1px solid #ddcece;
    position: relative;
`;